<template>
    <sidebar-left>
        <slot slot="sidebar-left">
            <SideMenu :SideMenuLinks="sideMenuLinks"></SideMenu>
        </slot>
        <slot slot="main">
            <div class="u-max-700 u-center-block">
                <page-header>
                    <slot slot="title">{{ $t('customer.account.addresses.title') }}</slot>
                    <slot slot="description">
                        <p v-html="IntroAddresses"></p>
                    </slot>
                </page-header>

                <section class="c-form-row o-page-bottom-spacing--medium">
                    <h2 class="c-title--border u-h3">
                        {{ $t('customer.account.addresses.invoice.title') }}
                    </h2>

                    <ul class="o-grid--third o-grid o-list--reset u-m--15">
                        <li class="u-flex u-p-15">
                            <router-link class="add-address" :to="{ name:'CustomerAccountAddressesCreate', params: { type: 'invoice' }}">
                                <svgicon name="add" width="84" height="84"></svgicon>
                                <span class="u-font-weight-bold u-font-small u-margin-top">
                                    {{ $t('customer.account.addresses.invoice.add_address') }}
                                </span>
                            </router-link>
                        </li>
                        <li class="u-flex u-p-15" v-for="InvoiceAddress in InvoiceAddresses" :key="InvoiceAddress.Name">
                            <article class="u-border u-padding-small u-fullwidth c-overlay-wrapper">
                                <div class="c-overlay">
                                    <button @click="deleteAddress(InvoiceAddress)" class="c-button c-button--small c-button--danger">
                                        {{ $t('customer.account.addresses.invoice.delete_address') }}
                                    </button>
                                </div>
                                <h3 class="u-margin-bottom-none u-font-inherit">
                                    {{ InvoiceAddress.Header }}
                                </h3>

                                <p v-if="InvoiceAddress.Street || InvoiceAddress.City || InvoiceAddress.CountryName">
                                    <span v-if="InvoiceAddress.Street">
                                        {{ InvoiceAddress.Street }}<br v-if="InvoiceAddress.City">
                                    </span>
                                        <span v-if="InvoiceAddress.City">
                                        {{ InvoiceAddress.ZipCode }} {{ InvoiceAddress.City }}<br v-if="InvoiceAddress.CountryName">
                                    </span>
                                        <span v-if="InvoiceAddress.CountryName">
                                        {{ InvoiceAddress.CountryName }}
                                    </span>
                                </p>

                                <ul class="c-nav u-font">
                                    <li v-if="InvoiceAddress.Email">
                                        <a :href="'mailto:' + InvoiceAddress.mail" class="c-icon-label u-text-truncate">
                                            <svgicon name="mail"></svgicon>
                                            <span>
                                                {{ InvoiceAddress.Email }}
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="InvoiceAddress.Phone">
                                        <span class="c-icon-label">
                                            <svgicon name="phone"></svgicon>
                                            <span>
                                            {{ InvoiceAddress.Phone }}
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </article>
                        </li>
                    </ul>
                </section>


                <section class="c-form-row o-page-bottom-spacing--medium">
                    <h2 class="c-title--border u-h3">
                        {{ $t('customer.account.addresses.delivery.title') }}
                    </h2>

                    <ul class="o-grid--third o-grid o-list--reset u-m--15">
                        <li class="u-flex u-p-15">
                            <router-link class="add-address" :to="{ name:'CustomerAccountAddressesCreate', params: { type: 'delivery' }}">
                                <svgicon name="add" width="84" height="84"></svgicon>
                                <span class="u-font-weight-bold u-font-small u-margin-top">
                                    {{ $t('customer.account.addresses.delivery.add_address') }}
                                </span>
                            </router-link>
                        </li>
                        <li class="u-flex u-p-15" v-for="DeliveryAddress in DeliveryAddresses" :key="DeliveryAddress.Name">
                            <article class="u-border u-padding-small u-fullwidth c-overlay-wrapper">
                                <div class="c-overlay">
                                    <button @click="deleteAddress(DeliveryAddress)" class="c-button c-button--small c-button--danger">
                                        {{ $t('customer.account.addresses.delivery.delete_address') }}
                                    </button>
                                </div>
                                <h3 class="u-margin-bottom-none u-font-inherit">
                                    {{ DeliveryAddress.Header }}
                                </h3>

                                <p v-if="DeliveryAddress.Street || DeliveryAddress.City || DeliveryAddress.CountryName">
                                    <span v-if="DeliveryAddress.Street">
                                        {{ DeliveryAddress.Street }}<br v-if="DeliveryAddress.City">
                                    </span>
                                    <span v-if="DeliveryAddress.City">
                                        {{ DeliveryAddress.ZipCode }} {{ DeliveryAddress.City }}<br v-if="DeliveryAddress.CountryName">
                                    </span>
                                    <span v-if="DeliveryAddress.CountryName">
                                        {{ DeliveryAddress.CountryName }}
                                    </span>
                                </p>

                                <ul class="c-nav u-font">
                                    <li v-if="DeliveryAddress.Email">
                                        <a :href="'mailto:' + DeliveryAddress.mail"
                                           class="c-icon-label u-text-truncate">
                                            <svgicon name="mail"></svgicon>
                                            <span>
                                                {{ DeliveryAddress.Email }}
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="DeliveryAddress.Phone">
                                        <span class="c-icon-label">
                                            <svgicon name="phone"></svgicon>
                                            <span>
                                            {{ DeliveryAddress.Phone }}
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </article>
                        </li>
                    </ul>
                </section>


                <section class="c-form-row o-page-bottom-spacing--medium">
                    <h2 class="c-title--border u-h3">
                        {{ $t('customer.account.addresses.shop.title') }}
                    </h2>

                    <ul class="o-grid--third o-grid o-list--reset u-m--15">
                        <li class="u-flex u-p-15">
                            <router-link class="add-address" :to="{ name:'CustomerAccountAddressesCreate', params: { type: 'other' }}">
                                <svgicon name="add" width="84" height="84"></svgicon>
                                <span class="u-font-weight-bold u-font-small u-margin-top">
                                    {{ $t('customer.account.addresses.shop.add_address') }}
                                </span>
                            </router-link>
                        </li>
                        <li class="u-flex u-p-15" v-for="ShopAddress in ShopAddresses" :key="ShopAddress.Name">
                            <article class="u-border u-padding-small u-fullwidth c-overlay-wrapper">
                                <div class="c-overlay">
                                    <button @click="deleteAddress(ShopAddress)" class="c-button c-button--small c-button--danger">
                                        {{ $t('customer.account.addresses.shop.delete_address') }}
                                    </button>
                                </div>
                                <h3 class="u-margin-bottom-none u-font-inherit">
                                    {{ ShopAddress.Header }}
                                </h3>

                                <p v-if="ShopAddress.Street || ShopAddress.City || ShopAddress.CountryName">
                                    <span v-if="ShopAddress.Street">
                                        {{ ShopAddress.Street }}<br v-if="ShopAddress.City">
                                    </span>
                                    <span v-if="ShopAddress.City">
                                        {{ ShopAddress.ZipCode }} {{ ShopAddress.City }}<br v-if="ShopAddress.CountryName">
                                    </span>
                                    <span v-if="ShopAddress.CountryName">
                                        {{ ShopAddress.CountryName }}
                                    </span>
                                </p>

                                <ul class="c-nav u-font">
                                    <li v-if="ShopAddress.Email">
                                        <a :href="'mailto:' + ShopAddress.mail" class="c-icon-label u-text-truncate">
                                            <svgicon name="mail"></svgicon>
                                            <span>
                                                {{ ShopAddress.Email }}
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="ShopAddress.Phone">
                                        <span class="c-icon-label">
                                            <svgicon name="phone"></svgicon>
                                            <span>
                                            {{ ShopAddress.Phone }}
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </article>
                        </li>
                    </ul>
                </section>


            </div>
        </slot>
    </sidebar-left>

</template>

<script>
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'
    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VTargetListSelect,
            VSwitch
        },
        created() {
            this.$store.dispatch('getDeliveryAddress', this.customerKey);
            this.$store.dispatch('getInvoiceAddress', this.customerKey);
            this.$store.dispatch('getShopAddress', this.customerKey);
        },
        data() {
            return {
                Validate: {},
                FunctionOptions: [
                    {
                        value: 'manager',
                        content: 'Zaakvoerder',
                        selected: true
                    },
                    {
                        value: 'strategist',
                        content: 'Strateeg'
                    }
                ],
            }
        },
        computed: {
            ...mapGetters({
                DeliveryAddresses: 'deliveryAddress',
                InvoiceAddresses: 'invoiceAddress',
                ShopAddresses: 'shopAddress'
            }),
            customerKey() {
                return parseInt(this.$store.getters.userInfo.customerKey);
            },
            IntroAddresses() {
                return this.$t('intro.customer_account_addresses');
            },
            sideMenuLinks() {
                let menu = [
                    {
                        title: 'customer.account.edit.title',
                        route: '/customer/account/edit',
                    }
                ];

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.users.title',
                        route: '/customer/account/users'
                    });
                    menu.push({
                        title: 'customer.account.addresses.title',
                        route: '/customer/account/addresses'
                    });
                }

                if(this.isCustomer || this.isMarketing) {
                    menu.push({
                        title: 'customer.account.history.title',
                        route: '/customer/account/history'
                    });

                    menu.push({
                        title: 'customer.account.backorders.title',
                        route: '/customer/account/backorders'
                    })
                }

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.invoices.title',
                        route: '/customer/account/invoices'
                    });
                }

                return menu;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        },
        methods: {
            deleteAddress(address) {
                const confirm = window.confirm(this.$t('customer.account.addresses.delete.confirmation'))
                if (confirm) {

                    this.$notify({
                        group: 'global',
                        title: this.$t('customer.account.addresses.delete.notification.title'),
                        text: this.$t('customer.account.addresses.delete.notification.text'),
                        type: 'success',
                        duration: 10000
                    });
                    this.$store.dispatch('deleteAddress', {
                        customer: this.customerKey,
                        body: address
                    });

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .add-address {
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        color: $color-alpha;
        border: solid 1px;
        text-decoration: none;
        transition: .15s ease-out;

        &:focus,
        &:hover {
            color: white;
            background-color: rgba($color-alpha, .8);
            border-color: $color-alpha;
            box-shadow: inset 0 0 0 1px $color-alpha;
        }
    }

    .u-m--15 {
        margin: -15px;
    }

    .u-p-15 {
        padding: 15px !important;
    }

    .c-overlay-wrapper {
        position: relative;
    }

    .c-overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(black, .75);
        transition: opacity .15s ease-out;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        > * {
            margin: 10px;
        }

        &:not(:hover) {
            opacity: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/customer/account/Addresses.vue